import Mip from "./Mip";

export default class Segmento implements SegmentoInterface {
  public segmento: string;
  public tipo: string;
  public tabelaAmortizacao: string;
  public sfh: number;
  public sfi: number;
  public comprometimento: number;
  public prazoMinimo: number;
  public prazoMaximo: number;
  public valorMinimo: number;
  public financiamentoMaximo: number;
  public dfi: number;
  public mips: Array<Mip>;
  public cota: number;

  constructor(object: SegmentoInterface) {
    if (object) {
      for (let key of Object.keys(object)) {
        // Se seguros, trata lista de retorno
        if (key === "mips") {
          let mipList: Array<Mip> = [];
          for (let item of object[key]) mipList.push(new Mip(item));

          this[key] = mipList;
        } else {
          this[key] = object[key];
        }
      }
    }
  }

  public sfhMensal(): number {
    return this.jurosMensal(this.sfh);
  }

  public sfiMensal(): number {
    return this.jurosMensal(this.sfi);
  }

  public jurosMensal(taxa: number): number {
    // return ((1 + taxa) ** (1 / 12) - 1) * 100;
    return (taxa / 12) * 100;
  }

  public valorFinanciamentoMaximo(valorImovel: number): number {
    return valorImovel * (this.financiamentoMaximo / 100);
  }

  public amortizacaoLabel(): string {
    return this.tabelaAmortizacao == "S" ? "SAC" : "PRICE";
  }

  public seguroDFI(valorImovel: number): number {
    return valorImovel * (this.dfi / 100);
  }

  public seguroMIP(valorFinanciamento: number, idade: number): number {
    return valorFinanciamento * (this.getMip(idade).percentage / 100);
  }

  private getMip(idade: number): Mip {
    let mip: Mip;
    for (let item of this.mips) {
      if (idade >= item.getMinMonth() && idade <= item.getMaxMonth()) {
        mip = item;
        break;
      }
    }
    if (!mip) {
      mip = this.mips[this.mips.length - 1];
    }

    return mip;
  }
}

interface SegmentoInterface {
  segmento: string;
  tipo: string;
  tabelaAmortizacao: string;
  sfh: number;
  sfi: number;
  comprometimento: number;
  prazoMinimo: number;
  prazoMaximo: number;
  valorMinimo: number;
  financiamentoMaximo: number;
  dfi: number;
  mips: Array<Mip>;
  cota: number;
}



// WEBPACK FOOTER //
// ./src/base/Segmento.ts